import { LeadCreationAction } from "@justhome/common/api/core";
import { Title } from "@justhome/react-ui";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "../../lib/hooks/useTranslations";
import LeadWallForm, { LeadWallFormValue } from "../LeadWallForm";
interface LeadWallBudgetFirstStepProps {
  leadCreationAction?: LeadCreationAction;
  onPrevious: VoidFunction;
  defaultValues?: Partial<LeadWallFormValue>;
  onSubmit: (value: LeadWallFormValue) => void;
  isLoading: boolean;
  isError: boolean;
  hasExplicitOptIn?: boolean;
}
const LeadWallBudgetFirstStep: FC<LeadWallBudgetFirstStepProps> = ({
  onPrevious,
  defaultValues,
  isLoading,
  isError,
  onSubmit,
  hasExplicitOptIn,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Title className={clsx("text-h1 mb-3s m:mb-3m")}>
        {t("lead_wall_title")}
      </Title>
      <LeadWallForm
        isError={isError}
        isLoading={isLoading}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        onPrevious={onPrevious}
        hasExplicitOptIn={hasExplicitOptIn}
      />
    </>
  );
};

export default LeadWallBudgetFirstStep;
